<template>
  <div class="app-container">
    <slider animation="fade" height="600" :control-btn="false" class="slider-box">
      <slider-item v-for="(i, index) in list" :key="index" :style="i">
        <div class="slider-content">
          <p>上海涛略信息技术有限公司</p>
          <p>搜狗输入法在信创领域的唯一合作方</p>
        </div>
      </slider-item>
    </slider>
    <div class="sec-list">
      <div class="card">
        <div class="title">产品介绍</div>
        <div class="title-sub mt10 mb10">全面的输入模式</div>
        <div class="content">拼音（9键、26键）、五笔（86、98、新世纪）、符号、表情、多语言手写、多语音离线语音、藏语、小语种</div>
        <div class="card-item-box flex">
          <div class="card-item" v-for="(item, index) in inputImgList" :key="index">
            <img v-lazy="item.src" />
            <div>{{ item.text }}</div>
          </div>
        </div>
        <div class="center">
          <div class="btn white" @click="toJump('product')">更多产品介绍</div>
        </div>
      </div>
    </div>
    <div class="sec-list sec-list-even apply-box position-box">
      <div class="card">
        <div class="title">应用领域</div>
        <div class="title-sub mt10 mb10">适用办公、教育、自助终端等诸多应用领域</div>
        <div class="card-item-box flex">
          <div class="card-item" v-for="(item, index) in apImgList" :key="index">
            <img v-lazy="item.src" />
            <div class="desc white title bolder">{{ item.text }}</div>
          </div>
        </div>
        <div class="btn white" @click="toJump('apply')">更多应用领域</div>
      </div>
    </div>
  </div>
</template>


<script>
import { Slider, SliderItem } from 'vue-easy-slider'
import { inputImgList, apImgList } from './const.js'
export default {
  data() {
    return {
      inputImgList,
      apImgList,
      list: [
        { backgroundColor: '#282828', width: '100%', height: '600px' },
        { backgroundColor: '#282828', width: '100%', height: '600px' },
        { backgroundColor: '#282828', width: '100%', height: '600px' },
      ],
    }
  },
  components: {
    Slider,
    SliderItem,
  },
  methods: {
    toJump(path) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.$router.push({
        path
      })
    },
  }
}
</script>
